(function() {
  const TAGS = "h1,h2,h3,h4,h5,h6,p,span,li";
  const selector = `.animacion-txt${TAGS ? `, .animacion-txt:is(${TAGS})` : ''}`;

  const CHUNK = 7;
  const START_OFFSET_PX = 0;
  const START_OFFSET_RATIO = 0.10;
  const SPEED = 400;

  function initScrollReveal() {
    const elements = document.querySelectorAll('.animacion-txt');
    if (!elements.length) return;

    elements.forEach((el) => {
      if (el.querySelector(".word")) return;

      const text = el.textContent;
      const formattedText = text.replace(
        /([¿¡]?[\p{L}\p{N}]+(?:[\p{L}\p{N}\p{M}]*)[?!.:,’]*|[\s]+)/gu,
        (m) => (/\s+/.test(m) ? m : `<span class="word">${m}</span>`)
      );

      el.innerHTML = formattedText;

      let run = 0;
      let totalChars = 0;
      const words = el.querySelectorAll(".word");
      words.forEach((w) => {
        const len = w.textContent.replace(/\s+/g, "").length;
        w.dataset.cum = String(run);
        w.dataset.wlen = String(len);
        run += len;
        totalChars += len;
        w.style.opacity = 0.3;
      });
      el.dataset.totalChars = String(totalChars);
    });

    const offsetByTag = {
      H1: 30, H2: 25, H3: 20, H4: 15, H5: 12, H6: 10, P: 18, LI: 16, SPAN: 14, DEFAULT: 18,
    };

    const onScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;

      document.querySelectorAll('.animacion-txt').forEach((host) => {
        const rect = host.getBoundingClientRect();
        const hostTop = rect.top + window.scrollY;
        const tag = host.tagName || "DEFAULT";
        const factor = offsetByTag[tag] ?? offsetByTag.DEFAULT;

        const startDelay = START_OFFSET_PX + rect.height * START_OFFSET_RATIO;
        const raw = (scrollPosition - hostTop - factor - startDelay) / SPEED;
        const progress = Math.max(0, Math.min(1, raw));

        const total = Number(host.dataset.totalChars || 0);
        if (!total) return;

        const rawChars = Math.max(0, Math.min(total, Math.round(progress * total)));
        let revealedChars;
        if (total - rawChars < CHUNK && rawChars > 0) {
          revealedChars = total;
        } else {
          revealedChars = Math.floor(rawChars / CHUNK) * CHUNK;
        }

        host.querySelectorAll(".word").forEach((w) => {
          const start = Number(w.dataset.cum || 0);
          const len = Number(w.dataset.wlen || 0);
          const end = start + len;

          if (end <= revealedChars) {
            w.style.opacity = 1;
          } else if (start < revealedChars && revealedChars < end) {
            w.style.opacity = 0.65;
          } else {
            w.style.opacity = 0.3;
          }
        });
      });
    };

    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    onScroll();
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initScrollReveal, 400);
  });
})();
